var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "end" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 18, lg: 16 },
            },
            [
              _c("label", { staticStyle: { width: "70px" } }, [
                _vm._v(_vm._s(_vm.$t("performance-analysis::shopName"))),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    popperAppendToBody: false,
                    placeholder: _vm.$t("system::common::select_placeholder"),
                  },
                  on: { change: _vm.changeShop },
                  model: {
                    value: _vm.selectedShop,
                    callback: function ($$v) {
                      _vm.selectedShop = $$v
                    },
                    expression: "selectedShop",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 6, lg: 8 },
            },
            [
              _c("label", { staticStyle: { width: "150px" } }, [
                _vm._v(_vm._s(_vm.$t("performance-analysis::orderDate"))),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  appendToBody: false,
                  clearable: false,
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": "~",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "10px" },
              on: {
                click: function ($event) {
                  _vm.$router.push({
                    path: _vm.reportJumpUrl().performAnalysis,
                  })
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("system::common::btn::check_report")) + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-content", attrs: { gutter: 20 } },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 6, md: 6, sm: 6, xl: 6 },
            },
            [
              _c("dataCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.card,
                    expression: "loading.card",
                  },
                ],
                attrs: { option: item },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.delieveredLineCharts,
                    expression: "loading.delieveredLineCharts",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.delieveredLineCharts },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.shipping,
                      expression: "loading.shipping",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.shippingTable },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopName",
                      label: _vm.$t(
                        "performance-analysis::send::table_shopName"
                      ),
                      "min-width": "130px",
                      showOverflowTooltip: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderNum",
                      label: _vm.$t("performance-analysis::send::table_order"),
                      "min-width": "150px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unshippingOrderNum",
                      label: _vm.$t(
                        "performance-analysis::send::table_notSend"
                      ),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "05DayShippingOrderNum",
                      label: _vm.$t(
                        "performance-analysis::send::table_fiveSendOrder"
                      ),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "05DayShippingRate",
                      label: _vm.$t(
                        "performance-analysis::send::table_fiveSendRate"
                      ),
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["05DayShippingRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "1015DayShippingOrderNum",
                      label: _vm.$t(
                        "performance-analysis::send::table_tenSendOrder"
                      ),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "1015DayShippingRate",
                      label: _vm.$t(
                        "performance-analysis::send::table_tenSendRate"
                      ),
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["1015DayShippingRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "15DayShippingOrderNum",
                      label: _vm.$t(
                        "performance-analysis::send::table_fifteenSendOrder"
                      ),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "15DayShippingRate",
                      label: _vm.$t(
                        "performance-analysis::send::table_fifteenSendRate"
                      ),
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["15DayShippingRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.delievered,
                      expression: "loading.delievered",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.delieveredTable },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopName",
                      label: _vm.$t(
                        "performance-analysis::receive::table_shopName"
                      ),
                      "min-width": "130px",
                      showOverflowTooltip: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay20ReceiveOrderNum",
                      label: _vm.$t(
                        "performance-analysis::receive::table_pay20order"
                      ),
                      "min-width": "190px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay20ReceiveRate",
                      label: _vm.$t(
                        "performance-analysis::receive::table_pay20orderRate"
                      ),
                      "min-width": "170px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["pay20ReceiveRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay30ReceiveOrderNum",
                      label: _vm.$t(
                        "performance-analysis::receive::table_pay30order"
                      ),
                      "min-width": "190px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay30ReceiveRate",
                      label: _vm.$t(
                        "performance-analysis::receive::table_pay30orderRate"
                      ),
                      "min-width": "170px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["pay30ReceiveRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipping20ReceiveOrderNum",
                      label: _vm.$t(
                        "performance-analysis::receive::table_send20order"
                      ),
                      "min-width": "190px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipping20ReceiveRate",
                      label: _vm.$t(
                        "performance-analysis::receive::table_send20orderRate"
                      ),
                      "min-width": "170px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["shipping20ReceiveRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipping30ReceiveOrderNum",
                      label: _vm.$t(
                        "performance-analysis::receive::table_send30order"
                      ),
                      "min-width": "190px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipping30ReceiveRate",
                      label: _vm.$t(
                        "performance-analysis::receive::table_send30orderRate"
                      ),
                      "min-width": "170px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row["shipping30ReceiveRate"]) + "%"
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }